/*
 * Webfontes, fora do CSS que o Tailwind processa.
 *
 * O Tailwind 4 inlina os `@import` do arquivo que ele recebe e cola as regras
 * como texto, sem rebasear as `url()` relativas. Quando estas ficavam em
 * `globals.css`, o Vite via `url(./files/…)` e `url(./fonts/…)` resolvidas a
 * partir do `styles.css` do app, onde essas pastas não existem: nenhuma fonte
 * era emitida no build e todas respondiam o index.html em produção.
 *
 * Importado direto do entry de cada app (`import '@estac1/ui/fonts.css'`), o
 * Vite resolve cada `@import` ele mesmo e reescreve as `url()` a partir do
 * arquivo de origem — que é o comportamento que o @fontsource espera.
 */

@import '@fontsource/geist-sans/400.css';
@import '@fontsource/geist-sans/500.css';
@import '@fontsource/geist-sans/600.css';
@import '@fontsource/geist-sans/700.css';
@import '@fontsource/geist-mono/400.css';
@import '@fontsource/geist-mono/500.css';

/*
 * GL-Nummernschild (FE-Mittelschrift): the official German license-plate font,
 * which is also the font used on Brazilian Mercosul plates. Open source by
 * Gutenberg Labo (https://github.com/Gutenberg-Labo/GL-Nummernschild).
 * Used only inside the <PlateInput> component so plates look like plates.
 */
@font-face {
  font-family: 'License Plate';
  src: url('./fonts/GL-Nummernschild-Mtl.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
